import { useEffect } from 'react';
import { User } from '@upstart/harmony/lib/legos/userTypes';
import { shouldRedirectToDeskingV3 } from 'util/deskingUtils';
import { useGrowthBook } from './GrowthBook';

export function useCommandCenterDeskingRedirect({
  redirectUrl,
  user,
}: {
  redirectUrl: string;
  user: User;
}) {
  const gb = useGrowthBook();

  async function shouldRedirect() {
    const redirectToDeskingV3 = await shouldRedirectToDeskingV3({ gb, user });
    if (redirectToDeskingV3) {
      window.location.assign(redirectUrl);
    }
  }

  useEffect(() => {
    shouldRedirect();
  }, [user, gb]);
}
